var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chart__svg-container"}},[_c('h2',{staticClass:"d-none"},[_vm._v(_vm._s(_vm.subject)+" over "+_vm._s(_vm.time))])])
}
var staticRenderFns = []

export { render, staticRenderFns }